import {Link} from 'react-router-dom';
import AurButton from '../../../common/aur-button/AurButton';
import {useState} from 'react';
import ECASavedSearchSelectionDialog from '../../../eca/ECASavedSearchSelectionDialog';

const DataGridTree: React.FC = () => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  return (
    <div style={{marginBottom: '64px'}}>
      <h1>DataGrid with Tree</h1>
      <Link to="/demo">Return</Link>
      <br />
      <div style={{marginTop: '32px'}}>
        <AurButton
          type="continue"
          title="Show Search Selection"
          label="Show Search Selection"
          onClick={setIsDialogVisible.bind(this, true)}
        />
      </div>
      <ECASavedSearchSelectionDialog
        isOpen={isDialogVisible}
        onClose={setIsDialogVisible.bind(this, false)}
        onSet={setIsDialogVisible.bind(this, false)}
      />
    </div>
  );
};

export default DataGridTree;
